export default {
  movie_host: 'https://pmovie.fanink.cn'
}
